import Location from "pages/Companies/Location"
import React, { useState } from "react"
import { FormGroup, Label, Input, Col, Row } from "reactstrap"

const ApplicantDetails = () => {
  const [applicantType, setApplicantType] = useState("")
  const [legalName, setLegalName] = useState("")
  const [tin, setTin] = useState("")
  const [registrationNumber, setRegistrationNumber] = useState("")
  const [contactPerson, setContactPerson] = useState("")
  const [contactTelephone, setContactTelephone] = useState("")
  const [locationAddress, setLocationAddress] = useState("")
  const [name, setName] = useState("")
  const [jobPosition, setJobPosition] = useState("")
  const [email, setEmail] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")

  const handleApplicantTypeChange = event => {
    setApplicantType(event.target.value)
  }

  return (
    <div>
      <Row>
        <Col md={4}>
          <Label for="applicant_type">Applicant Type</Label>
          <Input
            type="select"
            name="applicant_type"
            id="applicant_type"
            onChange={handleApplicantTypeChange}
          >
            <option value="">Select Applicant Type</option>
            <option value="Rwanda">Rwandan</option>
            <option value="Foreign">Foreigner</option>
          </Input>
        </Col>

        <Col md={8}>
          <Label for="applicant_name">Applicant Full Name</Label>
          <Input
            type="text"
            name="applicant_name"
            id="applicant_name"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
        </Col>
      </Row>
      <FormGroup></FormGroup>
      {applicantType === "Rwanda" && (
        <div>
          <FormGroup>
            <Label for="tin">TIN</Label>
            <Input
              type="text"
              name="tin"
              id="tin"
              value={tin}
              onChange={e => setTin(e.target.value)}
              required
            />
          </FormGroup>
        </div>
      )}

      <FormGroup>
        <Row className="mt-3">
          <Col md={4}>
            <Label for="applicant_position">Job Position</Label>
            <Input
              type="text"
              name="applicant_position"
              id="applicant_position"
              value={jobPosition}
              onChange={e => setJobPosition(e.target.value)}
              required
            />
          </Col>

          <Col md={4}>
            <Label for="applicant_email">Email</Label>
            <Input
              type="email"
              name="applicant_email"
              id="applicant_email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </Col>

          <Col md={4}>
            <Label for="applicant_phone">Phone Number</Label>
            <Input
              type="text"
              name="applicant_phone"
              id="applicant_phone"
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
              required
            />
          </Col>
        </Row>
      </FormGroup>
      <br></br>
      <h5>Applicant Address</h5>
      <Location />
    </div>
  )
}

export default ApplicantDetails
